<template>
  <div>
    <el-dialog title="服务详情" :visible.sync="show" width="30%">
      <jzdep :row="row"></jzdep>
      <el-divider></el-divider>
      <div v-if="row.status != '审核中'">
        <h3 style="margin-bottom: 10px">客服处理</h3>
        <div>处理人 ：{{ row.approvalName }}</div>
        <div style="margin: 10px 0">处理时间 ：{{ setTime(row.approvalTime) }}</div>
        <div>处理状态 ：{{ row.status }}</div>
        <div
          style="margin: 10px 0"
          v-if="
            row.result == '已确认' ||
            row.result == '已完成' ||
            row.result == '已支付' ||
            row.result == '已填写'
          "
        ></div>

        <div
          v-if="row.result == '已完成' || row.result == '已完善'"
          style="margin-top: 30px"
        >
          <h3 style="margin-bottom: 10px">服务</h3>
          <div>服务人姓名 ：{{ row.worker }}</div>
          <div style="margin: 10px 0">服务人手机号 :{{ row.workerPhone }}</div>
        </div>
        <div v-if="row.result == '已完成'">
          <div>完成状态 ：{{ row.result }}</div>
          <div style="margin: 10px 0">完成时间 ：{{ setTime(row.completeTime) }}</div>
        </div>
      </div>
      <div v-else>处理中</div>
      <div v-if="row.eflag">
        <h3 style="margin-bottom: 10px">评价详情</h3>
        <div>评价时间 ：{{ setTime(row.bdEvaluate.createTime) }}</div>
        <div style="margin: 10px 0">评价星级 ：{{ row.bdEvaluate.stars }}级</div>
        <div>评价内容 ：{{ row.bdEvaluate.content }}</div>
      </div>
      <div v-else>评价中</div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button v-hasPermi="['apply:serve:end']"  @click="successEnd" type="primary">结 束</el-button> -->
        <el-button @click="show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item label="报修人">
        <el-input v-model="form.username" placeholder="报修人" clearable=""></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getAll()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="data" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="username" label="申请人"></el-table-column>
      <el-table-column prop="phone" label="联系电话"></el-table-column>

      <el-table-column prop="projectName" label="服务项目"></el-table-column>
      <el-table-column prop="createTime" label="申请时间">
        <template slot-scope="{ row }">{{ setTime(row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="projectName" label="服务项目"></el-table-column>
      <el-table-column prop="worker" label="服务人员"></el-table-column>
      <el-table-column prop="approvalTime" label="处理时间">
        <template slot-scope="{ row }">{{ setTime(row.approvalTime) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="处理状态"></el-table-column>
      <el-table-column prop="date" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="getRow(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>

<script>
import jzdep from "./jzdep.vue";
export default {
  components: {
    jzdep,
  },
  data() {
    return {
      show: false,
      data: [],
      form: {
        result: "已完成",
        status: "", //
        username: "",
        currentPage: 1,
        pageSize: 10,
        type: "家政",
      },
      row: {},
      totalNum: 0,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    getRow(row) {
      this.row = row;
      this.show = true;
    },
    getAll() {
      this.$http.post(`/api/bdServiceApply/queryWebServiceApply`, this.form).then((r) => {
        if (r.data.data != null) {
          this.data = r.data.data.items;
          this.totalNum = r.data.data.totalNum;
        } else {
          this.data = null;
          this.totalNum = 0;
        }
      });
    },
    successEnd() {
      this.$confirm("是否确认结束当前服务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$http
            .get(`/api/bdServiceApply/saveServiceApply?id=${this.row.id}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success(res.data.message);
                this.show = false;
                this.getAll();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消",
          });
        });
    },
  },
  mounted() {
    this.getAll();
  },
};
</script>

<style></style>
